import { useMemo } from "react";

import { ApiKeyRolesActionItemForBulkActions } from "./types";
import useDeleteApiKeyRolesBulkAction from "./useDeleteApiKeyRolesBulkAction";

const useApiKeyRolesBulkActions = (): ApiKeyRolesActionItemForBulkActions[] => {
  const confirmDeleteApiKeyRolesBulkAction = useDeleteApiKeyRolesBulkAction();

  return useMemo(() => [confirmDeleteApiKeyRolesBulkAction], [confirmDeleteApiKeyRolesBulkAction]);
};

export default useApiKeyRolesBulkActions;